<template>
  <v-app>
    <div>
      <router-view></router-view>
    </div>
    <datAlert></datAlert>
    <datSnackbar></datSnackbar>
  </v-app>
</template>

<script>
import datAlert from '@/components/alerts/datAlert'
import datSnackbar from '@/components/alerts/datSnackbar'
import ServicesAuth from '@/services/srv-auth.js'
import ServiceEcomplaints from '@/services/srv-eComplaints'

import {version} from '../package'

export default {
  name: 'AppExpert',
  components: {
    datAlert,
    datSnackbar
  },
  mounted(){
    console.log(`ECANALDENUNCIAS v${version} - ${process.env.NODE_ENV}`)

    if(localStorage.getItem("token")){
      if(!localStorage.getItem("user") || !localStorage.getItem("dominio")){
        const payload = {
          tira: localStorage.getItem("token"),
          getAvatarSN: "S",
          appOrigin: 'ECANALDENUNCIAS',
          privWeb: 'N'
        }
        ServicesAuth.getTokenInfo(payload).then(response => {
          localStorage.setItem("user", response.data.usuario)
          localStorage.setItem("dominio", response.data.orgAlias)
        })
      }
      
      ServiceEcomplaints.getManagerPermission({}).then(response => { 
        localStorage.setItem("manager", response.dataRes) 
      })
    }
  }
}
</script>

<style lang="sass">
@import './assets/style/main'
</style>
